module.exports = __webpack_public_path__ + "img/light-arrow-left.bee709e7.svg";